/**
 * What a reader can ask about a tenant's models, offered before they type.
 *
 * Every one of these is sent to the agent verbatim, exactly as if it had been typed.
 * They were answered in the browser once, from the rows the page was already holding,
 * which was instant and always right and made the four most prominent controls on a
 * surface called Ask Data Studio the only ones that never asked it anything.
 *
 * Phrased as the reader's own question rather than as a description of a capability,
 * because clicking one is meant to read as having asked it. Same rule as
 * `modelQuestions.ts` for the per-model rail.
 */
export type TenantQuestionId = 'edits' | 'push' | 'performance' | 'deployed';

export interface TenantQuestion {
  id: TenantQuestionId;
  question: string;
}

export const TENANT_QUESTIONS: TenantQuestion[] = [
  { id: 'edits', question: 'What are recent unpublished edits?' },
  { id: 'push', question: 'Which models are pushed to the CRM?' },
  { id: 'performance', question: 'How do my live models perform?' },
  { id: 'deployed', question: 'When was the last update deployed?' },
];
